import useTranslationRoute from "@/components/live-event/hooks/use-translation-route";
import { ParamsProps } from "@/components/live-event/live-event";
import { useTranslate } from "@/i18n/useTranslationModules";
import { updateWorkingEvent } from "@/store/actions/admin/create-event";
import { updatePageModule } from "@/store/actions/admin/create-event/session";
import { useThunkDispatch, useTypedSelector } from "@/store/reducers/use-typed-selector";
import { PageModule, PageModuleType, Session } from "@/types/working-model";
import { updateTranslateKey } from "@/utils/utils";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

const useUpdateDescriptionModuleSessionTitle = () => {
	const params = useParams<ParamsProps>();
	const { language } = params;
	const dispatch = useDispatch();
	const thunkDispatch = useThunkDispatch();
	const namespace = useTranslationRoute();
	const { t } = useTranslate(namespace);
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const workingSession = useTypedSelector(state => state.CreateSessionReducer.workingSession);
	const token = useTypedSelector(state => state.AuthReducer.token);
	const user = useTypedSelector(state => state.AuthReducer.user);

	const workingEventSession = workingEvent?.sessions.find((s: Session) => s.session === workingSession?.session);
	const descriptionModule = workingEventSession?.modules.find((m: PageModule) => m.type === PageModuleType.description);

	return useCallback((newTitle?: string) => {
		if (newTitle && descriptionModule && workingEvent && workingEvent.sessions.length === 1) {
			const updatedModule = {
				translateString: descriptionModule?.content?.['title'],
				input: `<h3><span style="font-size: 25px;">${newTitle}</span></h3>`,
				baseLanguage: workingSession?.default_language || 'en',
				language
			};

			const _workingEvent = {
				...workingEvent,
				sessions: workingEvent.sessions.map(s => {
					if (s.session === workingEventSession?.session) {
						const _session: Session = {
							...s,
							modules: s.modules.map(m => {
								if (m.id === descriptionModule?.id) {
									const _page_module: PageModule = {
										...m,
										content: {
											...m.content,
											['title']: updateTranslateKey(updatedModule),
										},
									};
									return _page_module;
								}
								return m;
							}),
							title:
							{
								...s.title,
								...(language === s.default_language ? { base: newTitle } : {}),
								[language]: newTitle
							}
						};
						return _session;
					}
					return s;
				})
			};

			if (token) {
				thunkDispatch(updateWorkingEvent(_workingEvent, token));
			}

			dispatch(
				updatePageModule({
					...descriptionModule,
					content: {
						...descriptionModule.content,
						['title']: updateTranslateKey(updatedModule),
					},
				})
			);
		}
	}, [descriptionModule, dispatch, language, thunkDispatch, token, workingEvent, workingEventSession?.session, workingSession?.default_language]);
};

export default useUpdateDescriptionModuleSessionTitle;
